import { styled } from '@mui/material/styles'
import { InputBase, inputBaseClasses } from '@mui/material'

export const AppBarSearchInput = styled(InputBase)(({ theme }) => ({
  margin: '0 7px',

  [`& .${inputBaseClasses.input}`]: {
    color: theme.palette.neutral900,
    fontSize: theme.typography.subtitle1?.fontSize,
    fontWeight: theme.typography.subtitle1?.fontWeight,
  },
}))
